(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cs-faq-list"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.csFaqxReady) return;
    window.csFaqxReady = true;

    const setOpen = (item, open) => {
      const btn = item.querySelector('.cs-faqx__q');
      item.toggleAttribute('data-open', open);
      if (btn) btn.setAttribute('aria-expanded', String(open));
    };

    document.addEventListener('click', (event) => {
      const btn = event.target.closest('.cs-faqx__q');
      if (btn) {
        const item = btn.closest('.cs-faqx__item');
        const root = btn.closest('.cs-faqx');
        const open = !item.hasAttribute('data-open');
        if (open && root && root.hasAttribute('data-single')) {
          root.querySelectorAll('.cs-faqx__item[data-open]').forEach((other) => {
            if (other !== item) setOpen(other, false);
          });
        }
        setOpen(item, open);
        return;
      }

      const cta = event.target.closest('.cs-faqx__cta');
      if (!cta) return;
      const href = cta.getAttribute('href') || '';
      if (!href.startsWith('#') || href.length < 2) return;
      let target = document.getElementById(href.slice(1));
      if (!target) {
        target = document.querySelector('#offre, [data-buy-box], product-form-component, form[action*="/cart/add"]');
      }
      if (!target) return;
      event.preventDefault();
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
